export enum ModalDismissReasons {
  BACKDROP_CLICK,
  CLOSE_CLICKED,
  ESC
}
